import { render, staticRenderFns } from "./FormAddIncomingProductSupplier.vue?vue&type=template&id=064510b8&scoped=true"
import script from "./FormAddIncomingProductSupplier.vue?vue&type=script&lang=js"
export * from "./FormAddIncomingProductSupplier.vue?vue&type=script&lang=js"
import style0 from "./FormAddIncomingProductSupplier.vue?vue&type=style&index=0&id=064510b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064510b8",
  null
  
)

export default component.exports